import gql from 'graphql-tag'

export const createBarcodeLabel = gql`
  mutation CreateBarcodeLabel(
    $accountId: Int!
    $barcodeSheetId: Int
    $name: String
    $width: Float
    $height: Float
    $elements: String
  ) {
    createBarcodeLabel(
      input: {
        accountId: $accountId
        barcodeSheetId: $barcodeSheetId
        name: $name
        width: $width
        height: $height
        elements: $elements
      }
    ) {
      barcodeLabels {
        accountId
        barcodeSheetId
        name
        width
        height
        elements
        sheet {
          id
          accountId
          name
          size
          width
          height
          topMargin
          bottomMargin
          leftMargin
          rightMargin
          rows
          columns
          rowGutter
          columnGutter
          unit
        }
        barcodeSettings {
          id
          accountId
          barcodeLabelId
          name
          output
          barcodeType
          size
          labelFormat
          digits
          prefix
          startNumber
          startingCode
          dataSource
          entityId
          fieldId
          details
        }
      }
      errors
    }
  }
`

export const updateBarcodeLabel = gql`
  mutation UpdateBarcodeLabel(
    $accountId: Int!
    $id: Int!
    $barcodeSheetId: Int
    $name: String
    $width: Float
    $height: Float
    $elements: String
  ) {
    updateBarcodeLabel(
      input: {
        accountId: $accountId
        id: $id
        barcodeSheetId: $barcodeSheetId
        name: $name
        width: $width
        height: $height
        elements: $elements
      }
    ) {
      barcodeLabels {
        id
        accountId
        barcodeSheetId
        name
        width
        height
        elements
        sheet {
          id
          accountId
          name
          size
          width
          height
          topMargin
          bottomMargin
          leftMargin
          rightMargin
          rows
          columns
          rowGutter
          columnGutter
          unit
        }
        barcodeSettings {
          id
          accountId
          barcodeLabelId
          name
          output
          barcodeType
          size
          labelFormat
          digits
          prefix
          startNumber
          startingCode
          dataSource
          entityId
          fieldId
          details
        }
      }
      errors
    }
  }
`
